import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { Component } from 'preact';
import isEmail from 'validator/es/lib/isEmail';
import isEmpty from 'validator/es/lib/isEmpty';
import { AuctionAPI } from '../../api/AuctionClient';
import { FormValidation } from '../../util/FormValidation';
export class MailToOrganizerModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            mailInput: {
                name: "",
                email: "",
                body: "",
            },
            inputValid: false
        };
    }
    render() {
        const mailInput = this.state.mailInput;
        return (_jsxs("div", Object.assign({ class: `AuctionPanel__Modal modal is-clipped ${this.state.open === true ? 'is-active' : ''}` }, { children: [_jsx("div", { class: "modal-background", onClick: _ => { this.handleClose(); } }, void 0),
                _jsxs("section", Object.assign({ class: "modal-card" }, { children: [_jsxs("header", Object.assign({ class: "modal-card-head header" }, { children: [_jsx("p", Object.assign({ class: "modal-card-title" }, { children: "\u51FA\u54C1\u8005\u3078\u8CEA\u554F\u3059\u308B" }), void 0),
                                _jsx("i", Object.assign({ class: "icon times", onClick: _ => { this.handleClose(); } }, { children: "\u00D7" }), void 0)] }), void 0),
                        _jsxs("div", Object.assign({ class: "modal-card-body body" }, { children: [_jsxs("div", Object.assign({ class: "field" }, { children: [_jsx("label", Object.assign({ class: "label has-text-weight-bold" }, { children: "\u304A\u540D\u524D" }), void 0),
                                        _jsx("div", Object.assign({ class: "control" }, { children: _jsx("input", { class: "input", type: "text", placeholder: "\u6C0F\u540Dor\u30CB\u30C3\u30AF\u30CD\u30FC\u30E0", value: mailInput.name, onInput: e => { this.handleInput(e, 'name'); } }, void 0) }), void 0),
                                        _jsx("p", Object.assign({ class: "help has-text-weight-normal" }, { children: "\u304A\u5BA2\u69D8\u3092\u7279\u5B9A\u3059\u308B\u305F\u3081\u306E\u304A\u540D\u524D\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044" }), void 0)] }), void 0),
                                _jsxs("div", Object.assign({ class: "field" }, { children: [_jsx("label", Object.assign({ class: "label has-text-weight-bold" }, { children: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9" }), void 0),
                                        _jsx("div", Object.assign({ class: "control" }, { children: _jsx("input", { class: "input", type: "email", placeholder: "sample@domain.com", value: mailInput.email, onInput: e => { this.handleInput(e, 'email'); } }, void 0) }), void 0),
                                        _jsx("p", Object.assign({ class: "help has-text-weight-normal" }, { children: "\u51FA\u54C1\u8005\u3088\u308A\u8FD4\u4FE1\u3044\u305F\u3060\u304F\u305F\u3081\u306E\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044" }), void 0)] }), void 0),
                                _jsxs("div", Object.assign({ class: "field" }, { children: [_jsx("label", Object.assign({ class: "label has-text-weight-bold" }, { children: "\u8CEA\u554F" }), void 0),
                                        _jsx("div", Object.assign({ class: "control" }, { children: _jsx("textarea", { class: "textarea", placeholder: "\u8CEA\u554F\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044", value: mailInput.body, onInput: e => { this.handleInput(e, 'body'); } }, void 0) }), void 0),
                                        _jsx("p", Object.assign({ class: "help has-text-weight-normal" }, { children: "\u5165\u529B\u9802\u3044\u305F\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306B\u8CEA\u554F\u5185\u5BB9\u306E\u78BA\u8A8D\u304C\u5C4A\u304D\u307E\u3059" }), void 0)] }), void 0)] }), void 0),
                        _jsxs("footer", Object.assign({ class: "modal-card-foot is-justify-content-space-between" }, { children: [_jsx("div", Object.assign({ class: "is-size-6" }, { children: _jsx("span", { children: "FirstPayment\u00AEAuction" }, void 0) }), void 0),
                                _jsxs("div", { children: [_jsx("button", Object.assign({ type: "button", class: "button is-small is-link is-outlined", onClick: () => { this.handleClose(); } }, { children: "\u9589\u3058\u308B" }), void 0),
                                        _jsx("button", Object.assign({ type: "button", class: "button is-small is-link", disabled: this.state.inputValid === false, onClick: () => { this.handleSendMail(); } }, { children: "\u8CEA\u554F\u3092\u9001\u4FE1" }), void 0)] }, void 0)] }), void 0)] }), void 0)] }), void 0));
    }
    handleOpen() {
        document.documentElement.style.overflow = "hidden";
        this.setState({
            open: true
        });
    }
    handleClose() {
        document.documentElement.removeAttribute("style");
        this.setState({
            open: false
        }, () => {
            this.props.hookClose();
        });
    }
    handleInput(evt, fieldName) {
        const elm = evt.target;
        const mailInput = this.state.mailInput;
        mailInput[fieldName] = elm.value;
        this.setState({
            mailInput: mailInput
        }, () => {
            this.handleValidate();
        });
    }
    handleSendMail() {
        const { uuid } = this.props.auction;
        const { body, email, name } = this.state.mailInput;
        const params = {
            uuid: uuid,
            name: name,
            email: email,
            body: body
        };
        AuctionAPI.sendmail(params, this.props.env).then(() => {
            alert('質問を送信しました');
            this.handleClose();
        }).catch(e => {
            console.error(e);
            alert('質問の送信に失敗しました。お手数ですが送信するメールアドレスがご利用可能かご確認をお願いします。');
            throw e;
        });
    }
    handleValidate() {
        const constraint = [
            // ニックネーム
            {
                field: 'name',
                validate: [
                    [isEmpty, '必須入力です', false, null]
                ]
            }, {
                field: 'email',
                validate: [
                    [isEmpty, '必須入力です', false, null],
                    [isEmail, 'メールアドレスの形式で入力してください', true, null]
                ]
            }, {
                field: 'body',
                validate: [
                    [isEmpty, '必須入力です', false, null],
                ]
            }
        ];
        const errors = FormValidation.validate(constraint, this.state.mailInput);
        this.setState({
            inputValid: errors.hasErrors() === false
        });
    }
}
